/* eslint-disable no-restricted-syntax */
import { db } from '@/shared/services/firebase'
import {distanceBetween, geohashQueryBounds} from 'geofire-common'

const getUserById = async userId => {
  try {
    const doc = await db.collection('users')
      .doc(userId)
      .get()

    // Do not throw error if no user found since if this function called, then userId must be in the UI
    // return fullName: Deleted User to indicate deleted users, easier to find which user is deleted
    return doc.exists ? {...doc.data(), id: doc.id} : {id: userId, fullName: 'Deleted User'} // usually show user.fullName in UI
  } catch (error) {
    return Promise.reject(error)
  }
}

// Get users based on location geohash
const getUsersByLocation = async(center, radius, employeeType = null, roles = []) => {
  // Find gigs within given radius in KM
  const radiusCenter = [parseFloat(center.lat), parseFloat(center.lng)]
  const radiusInM = radius * 1000

  // Each item in 'bounds' represents a startAt/endAt pair. We have to issue
  // a separate query for each pair. There can be up to 9 pairs of bounds
  // depending on overlap, but in most cases there are 4.
  const bounds = geohashQueryBounds(radiusCenter, radiusInM)
  const promises = []
  for (const b of bounds) {
    let q = db
      .collection('users')
    
    if (employeeType) {
      const status = employeeType === 'tyontekijat' ? 'accepted' : 'pending'
      q = q.where('status', '==', status)
    }

    if (roles && roles.length > 0) {
      const searchField = employeeType === 'tyontekijat' ? 'role' : 'profession'
      q = q.where(searchField, 'in', roles)
    }
    q = q.orderBy('address.gps.geohash')
      .startAt(b[0])
      .endAt(b[1])

    promises.push(q.get())
  }

  return Promise.all(promises)
    .then(snapshots => {
      const matchingDocs = []
      for (const snap of snapshots) {
        for (const doc of snap.docs) {
          const lat = doc.get('address.gps.lat')
          const lng = doc.get('address.gps.lng')

          // We have to filter out a few false positives due to GeoHash
          // accuracy, but most will match
          const distanceInKM = distanceBetween(
            [parseFloat(lat), parseFloat(lng)],
            radiusCenter,
          )
          const distanceInM = distanceInKM * 1000
          if (distanceInM <= radiusInM) {
            matchingDocs.push({
              address: doc.get('address'),
              fullName: doc.get('fullName'),
              firstName: doc.get('firstName'),
              mobile: doc.get('mobile'),
              distanceInKM,
              id: doc.id,
            })
          }
        }
      }
      return matchingDocs
    })
    .catch(error => {
      throw error
    })
}

export {
  // eslint-disable-next-line import/prefer-default-export
  getUserById,
  getUsersByLocation
}
